import { z, TypeOf } from 'zod';
import { feature } from './ChatMessage';
import { objectId } from '../ObjectId';
import { fieldFilter } from '../FieldFilter';
import { categoryFilter } from '../CategoryFilter';

export const sortType = z.enum(['relevance', 'price-asc', 'price-desc']);

export const appliedFilters = z.object({
    appliedMaxPrice: z.number().int().nullable(),
    appliedMinPrice: z.number().int().nullable(),
    appliedCategoryFilters: z.array(categoryFilter),
    appliedFieldFilters: z.array(fieldFilter),
    appliedSortBy: sortType
});

export const chatContext = z.object({
    sessionId: objectId,
    appliedFilters: appliedFilters.optional().nullable(),
    feature
});

export type ChatContext = TypeOf<typeof chatContext>;
